import React from 'react';
import {Hero} from "../../components/hero/Hero";
import {ContactUsFormSection} from "../../components/contact-us/ContactUsFormSection";
import {Distributors} from "../../components/distributors/Distributors";
import {SearchManualSection} from "../../components/search-manual-section/SearchManualSection";
import {connect} from "react-redux";
import {SectionHeader} from "../../components/section-header/SectionHeader";
import {BasicAnimation} from "../../components/animations/BasicAnimation";
import {Helmet} from "react-helmet";

class SupportContainer extends React.Component {

  constructor(props) {
    super(props);
    let state = {};

    try {
      if(this.props.supportPage.acf){
        state = {
          heroTitle: this.props.supportPage.acf.obx_hero_title,
          heroLead: this.props.supportPage.acf.obx_hero_lead,
          introTitle: this.props.supportPage.acf.obx_introduction_title,
          introLead: this.props.supportPage.acf.obx_introduction_lead,
          tel: this.props.supportPage.acf.obx_support_hotline
        };
      }
    } catch(e){}

    try {
      state.heroImage = this.props.supportPage._embedded["wp:featuredmedia"][0].source_url;
    } catch(e){}


    this.state = state;
  }

  render(){
    return (

      <div>
        <Helmet>
          <title>{this.state.heroTitle + " | Obelux Aviation Lights"}</title>
          <meta name="description" content={this.state.heroLead}></meta>
          <meta name="og:description" content={this.state.heroLead}></meta>
          <meta name="og:image" content={require('../../assets/images/obelux.jpg')}></meta>
        </Helmet>



        <header>
          <Hero title={this.state.heroTitle}
                subtitle={this.state.heroLead}
                image={this.state.heroImage || require('../../assets/images/Obelux-Support_blue.jpg')}
                align="center"/>
        </header>
        <BasicAnimation duration={800} delay={0}>
          <SectionHeader align="center"
                       title={this.state.introTitle}
                       subtitle={this.state.introLead}/>
        </BasicAnimation>
        <BasicAnimation duration={800} delay={300}>
          <SearchManualSection tel={this.state.tel}/>
        </BasicAnimation>
        <BasicAnimation duration={800} delay={500}>
          <Distributors/>
        </BasicAnimation>
        <ContactUsFormSection/>
      </div>

    );
  }
}

export const Support = connect(
  state => ({
    supportPage: ( state.resolve.data && state.resolve.data.supportPage ) || []
  })
)(SupportContainer);



// WEBPACK FOOTER //
// ./src/views/support/Support.js